export default __webpack_public_path__ + "static/media/GrooveTube (4).523bc092.png";